import MainContainer from '../components/main/main-redux'

export default MainContainer
